import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const attachedFilesModalStyles = makeStyles((theme: Theme) =>
    createStyles({
        resultDocumentsList: {
            margin: "20px 0px 50px 0px",
        },
        modal: { display: "flex", alignItems: "center", justifyContent: "center" },
        main: {
            padding: "30px",
            minWidth: "30%",
            minHeight: "30%",
        },
        closeIcon: {
            float: "right",
            cursor: "pointer",
        },
        fileIconSpace: {
            display: "flex",
            color: "#270ADC",
            cursor: "pointer",
        },
        fileIcon: {
            margin: "-2px 3px 0px 0px",
        },
        disabledField: {
            display: "flex",
            color: "rgba(153, 153, 153, 1)",
            cursor: "auto",
        },
    })
);
